export default (callback) => {
    const scriptSpider = document.createElement('script');

    scriptSpider.async = true;
    scriptSpider.defer = true;
    scriptSpider.src = "https://cdnjs.cloudflare.com/ajax/libs/OverlappingMarkerSpiderfier/1.0.3/oms.min.js?spiderfier_callback=initSpiderfierCallback";
    document.head.appendChild(scriptSpider);

    window.initSpiderfierCallback = callback.bind(window);
}